import { isObject } from "@pineapplelab/util";
import { FBase } from "./FBase";
import { TranslationStatusEnum } from "../enums/translationStatus.enum";

export class Subtitle extends FBase {

	language: string = null;
	subtitleUrl: string = null;
	translationStatus: TranslationStatusEnum = null;

	constructor(json?: any) {
		super();
		if (isObject(json)) {
			this.fromJson(json);
		}
	}

}
export namespace Subtitle {

	export const PATH = 'subtitles';

}
